export const currencyOptions = [
  { value: "USD", label: "$ USD" },
  { value: "ARS", label: "$ ARS" },
  { value: "CAD", label: "$ CAD" },
  { value: "COP", label: "$ COP" },
  { value: "EUR", label: "€ EUR" },
  { value: "GBP", label: "£ GBP" },
  { value: "HKD", label: "HK$ HKD" },
  { value: "JPY", label: "¥ JPY" },
  { value: "INR", label: "₹ INR" },
  { value: "AED", label: "د.إ AED" },
  { value: "AUD", label: "A$ AUD" },
  { value: "CNY", label: "¥ CNY" },
  { value: "BRL", label: "R$ BRL" },
  { value: "NZD", label: "NZ$ NZD" },
  { value: "SGD", label: "S$ SGD" },
  { value: "MXN", label: "$ MXN" },
  { value: "KRW", label: "₩ KRW" },
  { value: "TWD", label: "NT$ TWD" },
  { value: "THB", label: "฿ THB" },
  { value: "CZK", label: "Kč CZK" },
  { value: "IDR", label: "Rp IDR" },
  { value: "MYR", label: "RM MYR" },
  { value: "VND", label: "₫ VND" },
  { value: "PAB", label: "฿ PAB" },
  { value: "PHP", label: "₱ PHP" },
  { value: "NOK", label: "kr NOK" },
  { value: "RUB", label: "₽ RUB" },
  { value: "SAR", label: "ر.س SAR" },
  { value: "ZAR", label: "R ZAR" },
  { value: "HUF", label: "Ft HUF" },
  { value: "SEK", label: "kr SEK" },
  { value: "DKK", label: "kr DKK" },
  { value: "JMD", label: "$ JMD" },
  { value: "EGP", label: "£ EGP" },
  { value: "MAD", label: "DH MAD" },
  { value: "CRC", label: "₡ CRC" },
  { value: "BGN", label: "Лв. BGN" },
];

export const countryOptions = [
  { value: "ALB", label: "Albania" },
  { value: "ARG", label: "Argentina" },
  { value: "AUS", label: "Australia" },
  { value: "AUT", label: "Austria" },
  { value: "BHR", label: "Bahrain" },
  { value: "BLR", label: "Belarus" },
  { value: "BEL", label: "Belgium" },
  { value: "BLZ", label: "Belize" },
  { value: "BRA", label: "Brazil" },
  { value: "BGR", label: "Bulgaria" },
  { value: "CAN", label: "Canada" },
  { value: "CYM", label: "Cayman Islands" },
  { value: "CHL", label: "Chile" },
  { value: "CHN", label: "China" },
  { value: "COL", label: "Colombia" },
  { value: "CRI", label: "Costa Rica" },
  { value: "HRV", label: "Croatia" },
  { value: "CZE", label: "Czech Republic" },
  { value: "DNK", label: "Denmark" },
  { value: "DOM", label: "Dominican Republic" },
  { value: "EGY", label: "Egypt" },
  { value: "EST", label: "Estonia" },
  { value: "FIN", label: "Finland" },
  { value: "FRA", label: "France" },
  { value: "DEU", label: "Germany" },
  { value: "GRC", label: "Greece" },
  { value: "GTM", label: "Guatemala" },
  { value: "GUY", label: "Guyana" },
  { value: "HKG", label: "Hong Kong" },
  { value: "HUN", label: "Hungary" },
  { value: "IND", label: "India" },
  { value: "IDN", label: "Indonesia" },
  { value: "IRL", label: "Ireland" },
  { value: "ISR", label: "Israel" },
  { value: "ITA", label: "Italy" },
  { value: "JAM", label: "Jamaica" },
  { value: "JPN", label: "Japan" },
  { value: "KEN", label: "Kenya" },
  { value: "KOR", label: "Korea, Republic of" },
  { value: "XKX", label: "Kosovo" },
  { value: "LTU", label: "Lithuania" },
  { value: "MAC", label: "Macau" },
  { value: "MKD", label: "Macedonia" },
  { value: "MYS", label: "Malaysia" },
  { value: "MEX", label: "Mexico" },
  { value: "NLD", label: "Netherlands" },
  { value: "NZL", label: "New Zealand" },
  { value: "NGA", label: "Nigeria" },
  { value: "NOR", label: "Norway" },
  { value: "PAN", label: "Panama" },
  { value: "PER", label: "Peru" },
  { value: "PHL", label: "Philippines" },
  { value: "POL", label: "Poland" },
  { value: "PRT", label: "Portugal" },
  { value: "ROU", label: "Romania" },
  { value: "SAU", label: "Saudi Arabia" },
  { value: "SRB", label: "Serbia" },
  { value: "SGP", label: "Singapore" },
  { value: "SVN", label: "Slovenia" },
  { value: "ZAF", label: "South Africa" },
  { value: "ESP", label: "Spain" },
  { value: "SWE", label: "Sweden" },
  { value: "CHE", label: "Switzerland" },
  { value: "TWN", label: "Taiwan" },
  { value: "THA", label: "Thailand" },
  { value: "TUR", label: "Turkey" },
  { value: "UKR", label: "Ukraine" },
  { value: "ARE", label: "United Arab Emirates" },
  { value: "GBR", label: "United Kingdom" },
  { value: "USA", label: "United States of America" },
  { value: "VNM", label: "Vietnam" },
];
